/**
 *  @class
 *  @function SocialShare
 */
class SocialShare {
  constructor() {
    this.container = document.querySelector('.share-article');
    this.links = document.querySelectorAll('.social');

    this.setupEventListeners();
  }
  setupEventListeners() {
    this.links.forEach((link) => {
      link.addEventListener('click', (event) => {
        let left = (screen.width / 2) - (640 / 2),
          top = (screen.height / 2) - (440 / 2) - 100;
        window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
        event.preventDefault();
      });
    });
  }
}
window.addEventListener('load', () => {
  if (typeof SocialShare !== 'undefined') {
    new SocialShare();
  }
});

class CopyText extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const el = e.target.closest('[data-copy-link]');
      const copyInput = el.querySelector('.copy-link-value');
      const copyMessage = el.querySelector('[data-message]');

      copyInput.focus();
      copyInput.select();
      copyInput.setSelectionRange(0, 99999);
      try {
        navigator.clipboard.writeText(copyInput.value);
      } catch (e) {
        console.log('Oops, cannot copy!', e);
      }
      copyInput.blur();

      el.classList.add('active');
      copyMessage.innerHTML = 'Link copied!';

      setTimeout(() => {
        el.classList.remove('active');
        copyMessage.innerHTML = '';
      }, 3000);
    })
  }
}

customElements.define('copy-text', CopyText);